import { Rule } from "./../../../models/Rule";
import { ImportPortefeuilleDetail } from "./../../../models/ImportPortefeuilleDetail";
import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-item-rule",
  templateUrl: "./item-rule.component.html",
  styleUrls: ["./item-rule.component.scss"],
})
export class ItemRuleComponent implements OnInit {
  @Input()
  portefeuilleDetail: ImportPortefeuilleDetail;

  @Input()
  rules: Rule[];

  constructor() {}

  ngOnInit() {}

  isRuleParcourue(codeRule: string) {
    return this.portefeuilleDetail.importRuleParcourues.some(
      (x) => x.codeRule === codeRule
    );
  }

  getRules() {
    return this.rules;
  }

  getAnotherRuleParcourues() {
    let ruleCodes = this.rules.map((a) => a.codeRule);
    let difference = this.portefeuilleDetail.importRuleParcourues.filter(
      (x) => !ruleCodes.includes(x.codeRule)
    );
    return difference;
  }
}
